import * as React from "react";

import { AlignHack, Root, Text } from "./Cross.styles";

interface CrossProps {
    text?: string;
}

export function Cross(props: CrossProps): JSX.Element {
    return (
        <Root>
            <AlignHack />
            <Text>{props.text ?? defaultCrossText}</Text>
        </Root>
    );
}

const defaultCrossText = (
    <>
        Этот блок в печатной форме заполняется
        <br />
        работником налогового органа
    </>
);
